import { datadogRumProvider } from '@40seas/frontend/libs/providers';
import baseAxios, { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';
import set from 'lodash/set';
import axiosRetry from 'axios-retry';
import { FeatureToggle } from '@40seas/entities/feature-toggles';

export class FeatureTogglesService {
    private readonly axios: AxiosInstance;

    constructor(apiUrl: string, headers: Record<string, string>) {
        this.axios = baseAxios.create({
            baseURL: apiUrl,
            headers: headers,
        });

        axiosRetry(this.axios, {
            retries: 3,
            retryCondition: (error: AxiosError) => error.code === 'ERR_NETWORK',
            onRetry: (retryCount: number, error: AxiosError, requestConfig: AxiosRequestConfig) => {
                console.warn(`Retrying request to ${requestConfig.url} for the ${retryCount} time.`);
            },
            retryDelay: (retryCount) => retryCount * 100,
        });

        this.axios.interceptors.response.use(
            (response) => response,
            (error: AxiosError) => {
                const errorMessage = datadogRumProvider.getErrorMessage(error);

                // Don't report 404 errors to Datadog - these are expected client errors, not application bugs
                if (error.response?.status !== 404) {
                    datadogRumProvider.reportToDatadog(set(error, ['response', 'data', 'message'], errorMessage));
                }

                throw error;
            },
        );
    }

    async getFeatureToggles(): Promise<FeatureToggle[]> {
        const {
            data: { results: toggles },
        } = await this.axios.get('feature-toggles?limit=1000');
        return toggles;
    }
}
